Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
};
Date.prototype.addMinutes = function (m) {
  this.setMinutes(this.getMinutes() + m);
  return this;
};


export function setAuthClient(state, client) {
  state.client = client;
}

export function setUser(state, user) {
  localStorage.setItem("user", JSON.stringify(user));
  state.user = user;
}

export function setPartner(state, partner) {
  localStorage.setItem("partner", JSON.stringify(partner));
  state.partner = partner;
}

export function logout(state) {
  localStorage.removeItem("user");
  state.user = null;
}